{
  "PROFILE_SETTINGS": {
    "LINK": "إعدادات الملف الشخصي",
    "TITLE": "إعدادات الملف الشخصي",
    "BTN_TEXT": "تعديل الملف الشخصي",
    "DELETE_AVATAR": "حذف الصورة الرمزية",
    "AVATAR_DELETE_SUCCESS": "تم حذف الصورة الشخصية بنجاح",
    "AVATAR_DELETE_FAILED": "حدث خطأ أثناء حذف الصورة الشخصية، الرجاء المحاولة مرة أخرى",
    "UPDATE_SUCCESS": "تم تحديث حسابك بنجاح",
    "PASSWORD_UPDATE_SUCCESS": "تم تغيير كلمة المرور بنجاح",
    "AFTER_EMAIL_CHANGED": "تم تحديث ملفك الشخصي بنجاح، الرجاء تسجيل الدخول مرة أخرى حيث أنه قد تم تغيير بيانات تسجيل الدخول الخاصة بك",
    "FORM": {
      "PICTURE": "صورة الملف الشخصي",
      "EMAIL_SIGNATURE_PICTURE": {
        "LABEL": "صورة توقيع البريد الإلكتروني",
        "HINT": "تُستخدم في توقيعات البريد الإلكتروني. يُستبدل {'{{'}email_signature_picture{'}}'} بعنوان URL لهذه الصورة (وليس وسم صورة) — استخدمه كمصدر للصورة (قيمة src لوسم img) في توقيعك أو في توقيع صندوق الوارد. إذا لم يتم تعيينها، فلن يتم إدراج أي شيء.",
        "DELETE_SUCCESS": "تم حذف صورة توقيع البريد الإلكتروني بنجاح",
        "DELETE_FAILED": "حدث خطأ أثناء حذف صورة توقيع البريد الإلكتروني، الرجاء المحاولة مرة أخرى"
      },
      "AVATAR": "صورة الملف الشخصي",
      "ERROR": "الرجاء إصلاح الأخطاء في النموذج",
      "REMOVE_IMAGE": "حذف",
      "UPLOAD_IMAGE": "رفع صورة",
      "UPDATE_IMAGE": "تحديث الصورة",
      "PROFILE_SECTION": {
        "TITLE": "الملف الشخصي",
        "NOTE": "عنوان بريدك الإلكتروني هو المعرف الخاص بك الذي ستستخدمه لتسجيل الدخول."
      },
      "SEND_MESSAGE": {
        "TITLE": "أختصار إرسال الرسائل",
        "NOTE": "يمكنك تحديد أختصار (إما Enter أو Cmd/Ctrl+Enter) استنادًا إلى تفضيلك في الكتابة.",
        "UPDATE_SUCCESS": "تم تحديث الإعدادات الخاصة بك بنجاح",
        "CARD": {
          "ENTER_KEY": {
            "HEADING": "Enter (↵)",
            "CONTENT": "إرسال الرسائل بالضغط على مفتاح (Enter) بدلاً من النقر على زر الإرسال."
          },
          "CMD_ENTER_KEY": {
            "HEADING": "Cmd/Ctrl + Enter (<unk> + <unk> )",
            "CONTENT": "إرسال الرسائل بالضغط على Cmd/Ctrl + إدخال المفتاح بدلاً من النقر على زر الإرسال."
          }
        }
      },
      "INTERFACE_SECTION": {
        "TITLE": "Interface",
        "NOTE": "خصّص مظهر لوحة التحكم الخاصة بك.",
        "FONT_SIZE": {
          "TITLE": "Font size",
          "NOTE": "Adjust the text size across the dashboard based on your preference.",
          "UPDATE_SUCCESS": "Your font settings have been updated successfully",
          "UPDATE_ERROR": "There is an error while updating the font settings, please try again",
          "OPTIONS": {
            "SMALLER": "Smaller",
            "SMALL": "Small",
            "DEFAULT": "افتراضي",
            "LARGE": "Large",
            "LARGER": "Larger",
            "EXTRA_LARGE": "Extra Large"
          }
        },
        "UI_LANGUAGE": {
          "TITLE": "لغة لوحة التحكم",
          "NOTE": "تجاوز لغة الحساب للوحة التحكم الخاصة بك. اتركه فارغاً لاستخدام لغة الحساب الافتراضية.",
          "USE_ACCOUNT_DEFAULT": "استخدام لغة الحساب الافتراضية",
          "API_SUCCESS": "تم تحديث لغة لوحة التحكم الخاصة بك بنجاح"
        },
        "MESSAGE_TRANSLATION": {
          "TITLE": "لغة الرسالة",
          "NOTE": "اختر ما إذا كنت تريد عرض الرسائل الأصلية أو ترجماتها",
          "ORIGINAL": "الأصلية",
          "TRANSLATED": "المترجمة"
        },
        "PASTE_BEHAVIOR": {
          "TITLE": "سلوك اللصق",
          "NOTE": "اختر كيفية معالجة المحتوى الملصق عند كتابة الرسائل",
          "UPDATE_SUCCESS": "تم تحديث إعدادات اللصق الخاصة بك بنجاح",
          "OPTIONS": {
            "PRESERVE_ALL": {
              "HEADING": "الحفاظ على كل التنسيق",
              "DESCRIPTION": "الاحتفاظ بكل التنسيق، بما في ذلك الجداول والأنماط وعناصر HTML الأخرى عند لصق المحتوى."
            },
            "TEXT_WITH_LINKS": {
              "HEADING": "نص مع الروابط فقط",
              "DESCRIPTION": "التحويل إلى نص عادي مع الحفاظ على الروابط القابلة للنقر عند لصق المحتوى."
            },
            "PLAIN_TEXT_ONLY": {
              "HEADING": "نص عادي فقط",
              "DESCRIPTION": "إزالة كل التنسيق وتحويله إلى نص عادي عند لصق المحتوى."
            }
          }
        },
        "REPLY_BOX_HEIGHT": {
          "TITLE": "ارتفاع صندوق الرد",
          "NOTE": "اضبط الحد الأدنى لارتفاع صندوق الرد كنسبة مئوية من ارتفاع الشاشة. ينطبق فقط على محادثات البريد الإلكتروني.",
          "UPDATE_SUCCESS": "تم تحديث إعداد ارتفاع صندوق الرد بنجاح",
          "PERCENT_LABEL": "الارتفاع (% من ارتفاع الشاشة)",
          "OPTIONS": {
            "DEFAULT": {
              "HEADING": "افتراضي",
              "DESCRIPTION": "يبدأ صندوق الرد صغيرًا وينمو أثناء الكتابة."
            },
            "CUSTOM": {
              "HEADING": "مخصص",
              "DESCRIPTION": "يكون صندوق الرد دائمًا بارتفاع لا يقل عن النسبة المئوية المختارة من ارتفاع الشاشة."
            }
          }
        }
      },
      "AUTO_NAVIGATION": {
        "TITLE": "الانتقال التلقائي إلى المحادثة التالية",
        "NOTE": "الانتقال تلقائياً إلى المحادثة المفتوحة التالية بعد حل المحادثة الحالية",
        "UPDATE_SUCCESS": "تم تحديث إعداد الانتقال التلقائي بنجاح"
      },
      "MESSAGE_SIGNATURE_SECTION": {
        "TITLE": "توقيع الرسالة الشخصية",
        "DESCRIPTION": "أنشئ توقيع رسالة فريد ليظهر في نهاية كل بريد إلكتروني ترسله. يمكنك أيضاً تضمين صورة داخل النص.",
        "NOTE": "إنشاء توقيع رسالة فريدة تظهر في نهاية كل رسالة ترسلها من أي صندوق وارد. يمكنك أيضًا تضمين صورة داخلية، مدعومة في الدردشة المباشرة، والبريد الإلكتروني، وصناديق API الواردة.",
        "BTN_TEXT": "حفظ توقيع الرسالة",
        "API_ERROR": "تعذر إرسال الرسالة! حاول مرة أخرى",
        "API_SUCCESS": "تم حفظ التوقيع بنجاح",
        "IMAGE_UPLOAD_ERROR": "تعذر رفع الصورة! حاول مرة أخرى",
        "IMAGE_UPLOAD_SUCCESS": "تم إضافة الصورة بنجاح. الرجاء النقر على الحفظ لحفظ التوقيع",
        "IMAGE_UPLOAD_SIZE_ERROR": "حجم الصورة يجب أن يكون أقل من {size}MB"
      },
      "MESSAGE_SIGNATURE": {
        "LABEL": "توقيع الرسالة",
        "ERROR": "توقيع الرسالة لا يمكن أن يكون فارغاً",
        "PLACEHOLDER": "أدخل توقيع رسالتك الشخصية هنا."
      },
      "PASSWORD_SECTION": {
        "TITLE": "كلمة المرور",
        "NOTE": "تعديل كلمة المرور الخاصة بك سيعيد ضبط تسجيلات الدخول الخاصة بك في الأجهزة الأخرى.",
        "BTN_TEXT": "تغيير كلمة المرور"
      },
      "ACCESS_TOKEN": {
        "TITLE": "رمز المصادقة",
        "NOTE": "يمكن استخدام رمز المصادقة هذا إذا كنت تبني تكاملاً قائماً على API",
        "COPY": "نسخ",
        "REGENERATE": "إعادة الإنشاء",
        "REGENERATE_SUCCESS": "تمت إعادة إنشاء رمز المصادقة بنجاح. يرجى تحديث أي تكاملات تستخدم الرمز القديم.",
        "REGENERATE_CONFIRM_TITLE": "إعادة إنشاء رمز المصادقة؟",
        "REGENERATE_CONFIRM_MESSAGE": "سيؤدي هذا إلى إبطال الرمز الحالي. ستتوقف أي تكاملات تستخدم الرمز القديم عن العمل."
      },
      "CHROME_EXTENSION": {
        "TITLE": "امتداد Chrome",
        "NOTE": "ثبّت امتداد Chrome الخاص بنا للحصول على إشعارات غنية بالمكالمات الهاتفية الواردة.",
        "INSTALL_BUTTON": "تثبيت الامتداد",
        "ALREADY_INSTALLED": "تم تثبيت الامتداد"
      },
      "AUDIO_NOTIFICATIONS_SECTION": {
        "TITLE": "Audio Alerts",
        "NOTE": "Enable audio alerts in dashboard for new messages and conversations.",
        "PLAY": "Play sound",
        "ALERT_TYPES": {
          "NONE": "لا شيء",
          "MINE": "المعين",
          "ALL": "الكل",
          "ASSIGNED": "My assigned conversations",
          "UNASSIGNED": "Unassigned conversations",
          "NOTME": "Open conversations assigned to others"
        },
        "ALERT_COMBINATIONS": {
          "NONE": "You haven't selected any options, you won't receive any audio alerts.",
          "ASSIGNED": "You'll receive alerts for conversations assigned to you.",
          "UNASSIGNED": "You'll receive alerts for any unassigned conversations.",
          "NOTME": "You'll receive alerts for conversations assigned to others.",
          "ASSIGNED+UNASSIGNED": "You'll receive alerts for your assigned conversations and any unattended ones.",
          "ASSIGNED+NOTME": "You'll receive alerts for conversations assigned to you and to others, but not for unassigned ones.",
          "NOTME+UNASSIGNED": "You'll receive alerts for unattended conversations and those assigned to others.",
          "ASSIGNED+NOTME+UNASSIGNED": "You'll receive alerts for all conversations."
        },
        "ALERT_TYPE": {
          "TITLE": "تنبيه الأحداث للمحادثات",
          "NONE": "لا شيء",
          "ASSIGNED": "المحادثات المعينة",
          "ALL_CONVERSATIONS": "كل المحادثات"
        },
        "DEFAULT_TONE": {
          "TITLE": "نغمة التنبيه:"
        },
        "CONDITIONS": {
          "TITLE": "شروط التنبيه:",
          "CONDITION_ONE": "إرسال تنبيهات صوتية فقط إذا كانت نافذة المتصفح غير نشطة",
          "CONDITION_TWO": "إرسال تنبيهات كل 30 ثانية حتى يتم قراءة جميع المحادثات المعينة"
        },
        "SOUND_PERMISSION_ERROR": "Autoplay is disabled in your browser. To hear alerts automatically, enable sound permission in your browser settings or interact with the page.",
        "READ_MORE": "اقرأ المزيد"
      },
      "EMAIL_NOTIFICATIONS_SECTION": {
        "TITLE": "إشعارات البريد الإلكتروني",
        "NOTE": "قم بتحديث تفضيلات إشعار البريد الإلكتروني الخاص بك من هنا",
        "CONVERSATION_ASSIGNMENT": "إرسال إشعارات البريد الإلكتروني عند إسناد محادثة لي",
        "CONVERSATION_CREATION": "إرسال إشعارات للبريد الإلكتروني عند ورود محادثة جديدة",
        "CONVERSATION_MENTION": "إرسال إشعارات بالبريد الإلكتروني عندما يتم ذكرك في محادثة",
        "ASSIGNED_CONVERSATION_NEW_MESSAGE": "إرسال إشعارات البريد الإلكتروني عند إنشاء رسالة جديدة في محادثة موكلة",
        "PARTICIPATING_CONVERSATION_NEW_MESSAGE": "إرسال إشعارات التنية عند إنشاء رسالة جديدة في محادثة موكلة",
        "SLA_MISSED_FIRST_RESPONSE": "Send email notifications when a conversation misses first response SLA",
        "SLA_MISSED_NEXT_RESPONSE": "Send email notifications when a conversation misses next response SLA",
        "SLA_MISSED_RESOLUTION": "Send email notifications when a conversation misses resolution SLA"
      },
      "NOTIFICATIONS": {
        "TITLE": "Notification preferences",
        "TYPE_TITLE": "Notification type",
        "EMAIL": "البريد الإلكتروني",
        "PUSH": "الإشعارات الفورية",
        "TYPES": {
          "CONVERSATION_CREATED": "A new conversation is created",
          "CONVERSATION_ASSIGNED": "A conversation is assigned to you",
          "CONVERSATION_MENTION": "You are mentioned in a conversation",
          "ASSIGNED_CONVERSATION_NEW_MESSAGE": "A new message is created in an assigned conversation",
          "PARTICIPATING_CONVERSATION_NEW_MESSAGE": "A new message is created in a participating conversation",
          "UNASSIGNED_CONVERSATION_NEW_MESSAGE": "يتم إنشاء رسالة جديدة في محادثة بدون وكيل متاح",
          "SLA_MISSED_FIRST_RESPONSE": "A conversation misses first response SLA",
          "SLA_MISSED_NEXT_RESPONSE": "A conversation misses next response SLA",
          "SLA_MISSED_RESOLUTION": "A conversation misses resolution SLA"
        },
        "BROWSER_PERMISSION": "Enable push notifications for your browser so you’re able to receive them",
        "ALLOW_NOTIFICATION_DURING_CALL": "السماح بإشعارات الدفع أثناء المكالمة",
        "TEST_PUSH": "اختبار",
        "TESTING": "جارٍ الاختبار...",
        "TEST_PUSH_DESCRIPTION": "أرسل إشعارات تجريبية للتحقق من إعدادك",
        "TEST_NOTIFICATION_ERROR": "فشل إرسال الإشعار التجريبي. يرجى المحاولة مرة أخرى.",
        "TEST_LOCAL_TITLE": "إشعار تجريبي (محلي)",
        "TEST_LOCAL_BODY": "هذا إشعار محلي من المتصفح. إذا رأيت هذا، فإن إشعارات المتصفح تعمل بشكل جيد!"
      },
      "API": {
        "UPDATE_SUCCESS": "يتم تحديث إعدادات الإشعارات بنجاح",
        "UPDATE_ERROR": "حدث خطأ أثناء تحديث الإعدادات، الرجاء المحاولة مرة أخرى"
      },
      "PUSH_NOTIFICATIONS_SECTION": {
        "TITLE": "إشعارات المتصفح",
        "NOTE": "قم بتحديث تفضيلات إشعارات المتصفح من هنا",
        "CONVERSATION_ASSIGNMENT": "إرسال إشعارات على المتصفح عند إسناد محادثة لي",
        "CONVERSATION_CREATION": "إرسال إشعارات المتصفح عند ورود محادثة جديدة",
        "CONVERSATION_MENTION": "إرسال إشعارات بالبريد الإلكتروني عندما يتم ذكرك او الاشارة اليك في محادثة",
        "ASSIGNED_CONVERSATION_NEW_MESSAGE": "إرسال إشعارات التنية عند إنشاء رسالة جديدة في محادثة موكلة",
        "PARTICIPATING_CONVERSATION_NEW_MESSAGE": "إرسال إشعارات التنية عند إنشاء رسالة جديدة في محادثة موكلة",
        "HAS_ENABLED_PUSH": "لقد قمت بتمكين الإشعارات لهذا المتصفح.",
        "REQUEST_PUSH": "تفعيل إشعارات المتصفح",
        "SLA_MISSED_FIRST_RESPONSE": "Send push notifications when a conversation misses first response SLA",
        "SLA_MISSED_NEXT_RESPONSE": "Send push notifications when a conversation misses next response SLA",
        "SLA_MISSED_RESOLUTION": "Send push notifications when a conversation misses resolution SLA"
      },
      "PROFILE_IMAGE": {
        "LABEL": "صورة الملف الشخصي"
      },
      "NAME": {
        "LABEL": "اسمك الكامل",
        "ERROR": "الرجاء إدخال اسم صالح",
        "PLACEHOLDER": "الرجاء إدخال اسمك الكامل"
      },
      "DISPLAY_NAME": {
        "LABEL": "اسم العرض",
        "ERROR": "الرجاء إدخال اسم عرض صالح",
        "PLACEHOLDER": "الرجاء إدخال اسم العرض، سيتم عرض هذا في المحادثات"
      },
      "POSITION": {
        "LABEL": "المنصب",
        "ERROR": "يرجى إدخال منصب صالح",
        "PLACEHOLDER": "يرجى إدخال منصبك"
      },
      "CUSTOM_LINE": {
        "LABEL": "سطر مخصص",
        "ERROR": "يرجى إدخال سطر مخصص صالح",
        "PLACEHOLDER": "يرجى إدخال سطرك المخصص"
      },
      "AVAILABILITY": {
        "LABEL": "التوفر",
        "STATUS": {
          "ONLINE": "متصل",
          "BUSY": "مشغول",
          "OFFLINE": "غير متصل"
        },
        "SET_AVAILABILITY_SUCCESS": "تم تعيين التوافر بنجاح",
        "SET_AVAILABILITY_ERROR": "تعذر تعيين التوافر، الرجاء المحاولة مرة أخرى"
      },
      "EMAIL_PREVIEW_FORMAT": {
        "TITLE": "تنسيق معاينة البريد الإلكتروني في قائمة المحادثات",
        "NOTE": "اختر ما يظهر في قائمة المحادثات للمحادثات القادمة من صناديق البريد الإلكتروني",
        "SUBJECT": "الموضوع",
        "SUBJECT_WITH_NOTE": "الموضوع وآخر رسالة إذا كانت ملاحظة داخلية",
        "UPDATE_SUCCESS": "تم تحديث إعداد معاينة البريد الإلكتروني بنجاح"
      },
      "DISABLE_SHORTCUTS": {
        "TITLE": "تعطيل اختصارات لوحة المفاتيح",
        "NOTE": "إيقاف جميع اختصارات لوحة المفاتيح في التطبيق",
        "UPDATE_SUCCESS": "تم تحديث إعداد اختصارات لوحة المفاتيح بنجاح"
      },
      "FOLDER_ORDER": {
        "TITLE": "ترتيب المجلدات",
        "NOTE": "خصّص الترتيب الذي تظهر به المجلدات (طرق العرض المخصصة) في الشريط الجانبي. اسحب وأفلت لإعادة الترتيب.",
        "NO_FOLDERS": "لم يتم العثور على مجلدات مخصصة. أنشئ مجلدات لتنظيم محادثاتك."
      },
      "SIDEBAR_CONFIGURATION": {
        "TITLE": "تهيئة الشريط الجانبي",
        "NOTE": "خصّص الأقسام التي تظهر في الشريط الجانبي للمحادثات.",
        "SAVE_BUTTON": "حفظ التهيئة",
        "UPDATE_SUCCESS": "تم تحديث تهيئة الشريط الجانبي بنجاح",
        "UPDATE_ERROR": "حدث خطأ أثناء تحديث تهيئة الشريط الجانبي، يرجى المحاولة مرة أخرى",
        "OPTIONS": {
          "ALL_CONVERSATIONS": "كل المحادثات",
          "ALL_CONVERSATIONS_DESC": "إظهار عنصر القائمة \"كل المحادثات\" في الشريط الجانبي",
          "INBOX": "صندوق الوارد",
          "INBOX_DESC": "إظهار صندوق الوارد الرئيسي مع الإشعارات غير المقروءة",
          "CONVERSATION_GROUPS": "الإشارات وبدون حضور",
          "CONVERSATION_GROUPS_DESC": "إظهار مجموعتي المحادثات: الإشارات وبدون حضور",
          "FOLDERS": "المجلدات",
          "FOLDERS_DESC": "إظهار طرق العرض المخصصة (المجلدات) لتنظيم المحادثات",
          "TEAMS": "الفرق",
          "TEAMS_DESC": "إظهار المحادثات مصفاة حسب تعيينات الفريق",
          "CHANNELS": "صناديق الوارد",
          "CHANNELS_DESC": "إظهار المحادثات مصفاة حسب صندوق الوارد",
          "LABELS": "الوسوم",
          "LABELS_DESC": "إظهار المحادثات مصفاة حسب الوسوم"
        }
      },
      "PHONE_SETTINGS": {
        "TITLE": "إعدادات الهاتف",
        "NOTE": "أدخل بيانات اعتماد تسجيل الدخول إلى نظام PBX الخاص بك.",
        "USERNAME": "اسم المستخدم",
        "PASSWORD": "كلمة المرور",
        "SUBMIT": "حفظ",
        "USERNAME_INVALID": "يمكن أن يحتوي اسم المستخدم على أحرف وأرقام و . _ - + فقط — بدون مسافات وبدون عنوان بريد إلكتروني.",
        "API": {
          "USERNAME_INVALID": "اسم المستخدم ليس اسم مستخدم SIP صالحاً. استخدم الأحرف والأرقام و . _ - + فقط — بدون مسافات وبدون عنوان بريد إلكتروني.",
          "USERNAME_TAKEN": "اسم المستخدم هذا مستخدم بالفعل من قِبل وكيل آخر في هذا الحساب."
        }
      },
      "EMAIL": {
        "LABEL": "عنوان البريد الإلكتروني الخاص بك",
        "ERROR": "الرجاء إدخال عنوان بريد إلكتروني صحيح",
        "PLACEHOLDER": "الرجاء إدخال عنوان البريد الإلكتروني الخاص بك، سيتم عرضه في المحادثات"
      },
      "CURRENT_PASSWORD": {
        "LABEL": "كلمة المرور الحالية",
        "ERROR": "الرجاء إدخال كلمة مرور جديدة",
        "PLACEHOLDER": "الرجاء إدخال كلمة مرور جديدة"
      },
      "PASSWORD": {
        "LABEL": "كلمة مرور جديدة",
        "ERROR": "الرجاء إدخال كلمة مرور بطول 6 أحرف أو أكثر",
        "PLACEHOLDER": "الرجاء إدخال كلمة مرور جديدة"
      },
      "PASSWORD_CONFIRMATION": {
        "LABEL": "تأكيد كلمة المرور الجديدة",
        "ERROR": "تأكيد كلمة المرور يجب أن تتطابق",
        "PLACEHOLDER": "الرجاء إعادة إدخال كلمة المرور"
      }
    }
  },
  "SIDEBAR_ITEMS": {
    "CHANGE_AVAILABILITY_STATUS": "يتغيرون",
    "CHANGE_ACCOUNTS": "Switch account",
    "SWITCH_ACCOUNT": "Switch account",
    "CONTACT_SUPPORT": "Contact support",
    "REPORT_BUG": "الإبلاغ عن مشكلة",
    "SELECTOR_SUBTITLE": "اختر حساباً من القائمة التالية",
    "PROFILE_SETTINGS": "Profile settings",
    "KEYBOARD_SHORTCUTS": "Keyboard shortcuts",
    "APPEARANCE": "Change appearance",
    "SUPER_ADMIN_CONSOLE": "SuperAdmin console",
    "DOCS": "Read documentation",
    "LOGOUT": "Log out"
  },
  "BUG_REPORT": {
    "TITLE": "الإبلاغ عن مشكلة",
    "DESCRIPTION_LABEL": "وصف المشكلة",
    "DESCRIPTION_PLACEHOLDER": "صف المشكلة التي واجهتها...",
    "SUBMIT": "إرسال البلاغ",
    "SUBMITTING": "جارٍ الإرسال...",
    "CANCEL": "إلغاء",
    "SUCCESS": "تم إرسال البلاغ بنجاح. شكراً لك!",
    "VALIDATION_ERROR": "يرجى وصف المشكلة قبل الإرسال"
  },
  "APP_GLOBAL": {
    "TRIAL_MESSAGE": "أيام متبقية من الفترة التجريبية.",
    "TRAIL_BUTTON": "اشترك الآن",
    "DELETED_USER": "المستخدم المحذوف",
    "EMAIL_VERIFICATION_PENDING": "يبدو أنك لم تتحقق من عنوان بريدك الإلكتروني بعد. الرجاء التحقق من صندوق الوارد الخاص بك للتحقق من البريد الإلكتروني.",
    "RESEND_VERIFICATION_MAIL": "إعادة إرسال رسالة التحقق",
    "EMAIL_VERIFICATION_SENT": "تم إرسال البريد الإلكتروني للتحقق. الرجاء التحقق من البريد الوارد الخاص بك.",
    "ACCOUNT_SUSPENDED": {
      "TITLE": "تم تعليق الحساب",
      "MESSAGE": "تم تعليق حسابك. يرجى الاتصال بفريق الدعم للمزيد من المعلومات."
    }
  },
  "COMPONENTS": {
    "CODE": {
      "BUTTON_TEXT": "نسخ",
      "CODEPEN": "فتح في CodePen",
      "COPY_SUCCESSFUL": "تم نسخ الكود إلى الحافظة بنجاح"
    },
    "SHOW_MORE_BLOCK": {
      "SHOW_MORE": "إظهار المزيد",
      "SHOW_LESS": "إظهار أقل"
    },
    "FILE_BUBBLE": {
      "DOWNLOAD": "تنزيل",
      "UPLOADING": "جاري الرفع...",
      "INSTAGRAM_STORY_UNAVAILABLE": "هذه القصة لم تعد متاحة.",
      "RECORDING_UNAVAILABLE": "هذا التسجيل لم يعد متاحاً.",
      "DELETE_RECORDING": {
        "BUTTON": "حذف تسجيل المكالمة",
        "TITLE": "حذف تسجيل المكالمة؟",
        "DESCRIPTION": "سيتم حذف جميع تسجيلات هذه المكالمة نهائيًا من النظام الهاتفي ولا يمكن استعادتها. سيبقى نص المكالمة وملخصها.",
        "CONFIRM": "حذف",
        "SUCCESS": "تم حذف تسجيل المكالمة",
        "ERROR": "تعذر حذف تسجيل المكالمة. يُرجى المحاولة مرة أخرى."
      }
    },
    "LOCATION_BUBBLE": {
      "SEE_ON_MAP": "مشاهدة على الخريطة"
    },
    "FORM_BUBBLE": {
      "SUBMIT": "إرسال"
    },
    "MEDIA": {
      "IMAGE_UNAVAILABLE": "This image is no longer available.",
      "LOADING_FAILED": "Loading failed"
    }
  },
  "CONFIRM_EMAIL": "جار التحقق...",
  "SETTINGS": {
    "INBOXES": {
      "NEW_INBOX": "إضافة قناة تواصل"
    }
  },
  "SIDEBAR": {
    "NO_ITEMS": "No items",
    "CURRENTLY_VIEWING_ACCOUNT": "مشاهدة حاليا:",
    "SWITCH": "تبديل",
    "INBOX_VIEW": "Inbox View",
    "CONVERSATIONS": "المحادثات",
    "INBOX": "My Inbox",
    "ALL_CONVERSATIONS": "كل المحادثات",
    "MENTIONED_CONVERSATIONS": "الإشارات",
    "PARTICIPATING_CONVERSATIONS": "شارك",
    "UNATTENDED_CONVERSATIONS": "بدون حضور",
    "REPORTS": "التقارير",
    "SETTINGS": "الإعدادات",
    "CONTACTS": "جهات الاتصال",
    "DATA_ASSISTANT": "مساعد البيانات",
    "CAPTAIN": "قائد",
    "CAPTAIN_ASSISTANTS": "Assistants",
    "CAPTAIN_DOCUMENTS": "Documents",
    "CAPTAIN_RESPONSES": "FAQs",
    "HOME": "الرئيسية",
    "AGENTS": "وكيل الدعم",
    "AGENT_BOTS": "الروبوتات",
    "AUDIT_LOGS": "سجلات التدقيق",
    "WHATSAPP_TEMPLATES": "قوالب الواتساب",
    "BLOCKED_DOMAINS": "SPAM",
    "INBOXES": "قنوات التواصل",
    "NOTIFICATIONS": "الإشعارات",
    "CANNED_RESPONSES": "الردود الجاهزة",
    "INTEGRATIONS": "خيارات الربط",
    "PROFILE_SETTINGS": "إعدادات الملف الشخصي",
    "ACCOUNT_SETTINGS": "إعدادات الحساب",
    "APPLICATIONS": "التطبيقات",
    "LABELS": "الوسوم",
    "CUSTOM_ATTRIBUTES": "سمات مخصصة",
    "AUTOMATION": "الأتمتة",
    "MACROS": "ماكروس",
    "TEAMS": "الفرق",
    "BILLING": "الفواتير",
    "CUSTOM_VIEWS_FOLDER": "المجلدات",
    "CUSTOM_VIEWS_SEGMENTS": "الأجزاء",
    "ALL_CONTACTS": "جميع جهات الاتصال",
    "TAGGED_WITH": "مشار إليه بواسطة",
    "NEW_LABEL": "علامة جديدة",
    "NEW_TEAM": "فريق جديد",
    "NEW_INBOX": "صندوق الوارد الجديد",
    "REPORTS_CONVERSATION": "المحادثات",
    "CSAT": "تقييم رضاء العملاء",
    "LIVE_CHAT": "Live Chat",
    "SMS": "SMS",
    "CAMPAIGNS": "الحملات",
    "ONGOING": "جارية",
    "ONE_OFF": "إيقاف واحد",
    "REPORTS_SLA": "SLA",
    "REPORTS_BOT": "رد آلي",
    "REPORTS_AGENT": "وكيل الدعم",
    "REPORTS_LABEL": "الوسوم",
    "REPORTS_INBOX": "صندوق الوارد",
    "REPORTS_TEAM": "الفريق",
    "REPORTS_PHONE": "الهاتف",
    "WALLBOARD": "Wallboard",
    "WALLBOARD_OVERVIEW": "نظرة عامة",
    "WALLBOARD_QUEUES": "قوائم الانتظار",
    "DATA_ASSISTANT_CHAT": "الدردشة",
    "DATA_ASSISTANT_REPORTS": "التقارير",
    "NO_WAITING_CALLERS": "لا يوجد متصلون في الانتظار",
    "WAITING_CALLERS": "{count} متصل في الانتظار",
    "SET_AVAILABILITY_TITLE": "تعيين نفسك كـ",
    "SET_YOUR_AVAILABILITY": "قم بتعيين توافرك",
    "AVAILABILITY_IMPERSONATING": "مقفل أثناء تسجيل الدخول كهذا المستخدم",
    "SLA": "SLA",
    "CUSTOM_ROLES": "Custom Roles",
    "NEW_CONVERSATION": "محادثة جديدة",
    "DRAFT": "مسودة",
    "BETA": "تجريبي",
    "REPORTS_OVERVIEW": "نظرة عامة",
    "REAUTHORIZE": "انتهت صلاحية اتصال صندوق الوارد الخاص بك، يرجى إعادة الاتصال\n لمواصلة تلقي وإرسال الرسائل",
    "HELP_CENTER": {
      "TITLE": "مركز المساعدة",
      "ARTICLES": "Articles",
      "CATEGORIES": "الفئات",
      "LOCALES": "اللغات",
      "SETTINGS": "الإعدادات",
      "DICTIONARY": "القاموس"
    },
    "CHANNELS": "القنوات",
    "SET_AUTO_OFFLINE": {
      "TEXT": "وضع علامة غير متصل تلقائيا",
      "INFO_TEXT": "السماح للنظام بوضع علامة غير متصل تلقائياً عند عدم استخدام التطبيق أو لوحة التحكم.",
      "INFO_SHORT": "Automatically mark offline when you aren't using the app."
    },
    "DOCS": "قراءة المستندات"
  },
  "BLOCKED_DOMAINS_SETTINGS": {
    "HEADER": "النطاقات وجهات الاتصال المحظورة",
    "DESCRIPTION": "قائمة نطاقات البريد الإلكتروني المحظورة لهذا الحساب.",
    "NO_BLOCKED_DOMAINS": "لم يتم العثور على نطاقات محظورة.",
    "BLOCKED_CONTACTS_BTN": "جهات الاتصال المحظورة"
  },
  "BILLING_SETTINGS": {
    "TITLE": "الفواتير",
    "DESCRIPTION": "Manage your subscription here, upgrade your plan and get more for your team.",
    "CURRENT_PLAN": {
      "TITLE": "الباقة الحالية",
      "PLAN_NOTE": "أنت مشترك حاليا في باقة**{plan}** مع تراخيص **{quantity}**",
      "SEAT_COUNT": "Number of seats",
      "RENEWS_ON": "Renews on"
    },
    "VIEW_PRICING": "View Pricing",
    "MANAGE_SUBSCRIPTION": {
      "TITLE": "إدارة الاشتراك الخاص بك",
      "DESCRIPTION": "عرض فواتيرك السابقة، تحرير تفاصيل الفوترة الخاصة بك، أو إلغاء اشتراكك.",
      "BUTTON_TXT": "الذهاب إلى بوابة الفوترة"
    },
    "CAPTAIN": {
      "TITLE": "قائد",
      "DESCRIPTION": "Manage usage and credits for Captain AI.",
      "BUTTON_TXT": "Buy more credits",
      "DOCUMENTS": "Documents",
      "RESPONSES": "Responses",
      "UPGRADE": "Captain is not available on the free plan, upgrade now to get access to assistants, copilot and more."
    },
    "CHAT_WITH_US": {
      "TITLE": "تحتاج مساعدة؟",
      "DESCRIPTION": "هل تواجه أي مشاكل في الفواتير؟ نحن هنا للمساعدة.",
      "BUTTON_TXT": "تحدث الينا"
    },
    "NO_BILLING_USER": "حساب الفوترة الخاص بك قيد الإعداد. الرجاء تحديث الصفحة وحاول مرة أخرى."
  },
  "CREATE_ACCOUNT": {
    "NO_ACCOUNT_WARNING": "أوه! لم نتمكن من العثور على الحساب. الرجاء إنشاء حساب جديد للمتابعة.",
    "NEW_ACCOUNT": "حساب جديد",
    "SELECTOR_SUBTITLE": "إنشاء حساب جديد",
    "API": {
      "SUCCESS_MESSAGE": "تم إنشاء الحساب بنجاح",
      "EXIST_MESSAGE": "الحساب موجود بالفعل",
      "ERROR_MESSAGE": "تعذر الاتصال بالخادم، الرجاء المحاولة مرة أخرى لاحقاً"
    },
    "FORM": {
      "NAME": {
        "LABEL": "اسم المنشأة",
        "PLACEHOLDER": "مؤسسة Wayne"
      },
      "SUBMIT": "إرسال",
      "CANCEL": "إلغاء"
    }
  },
  "KEYBOARD_SHORTCUTS": {
    "TOGGLE_MODAL": "عرض جميع الاختصارات",
    "TITLE": {
      "OPEN_CONVERSATION": "فتح المحادثة",
      "RESOLVE_AND_NEXT": "حل وانتقل إلى التالي",
      "NAVIGATE_DROPDOWN": "تصفح العناصر المنسدلة",
      "RESOLVE_CONVERSATION": "إعادة فتح المحادثة",
      "GO_TO_CONVERSATION_DASHBOARD": "الذهاب إلى لوحة المحادثة",
      "ADD_ATTACHMENT": "إضافة مرفقات",
      "GO_TO_CONTACTS_DASHBOARD": "الذهاب إلى لوحة جهات الاتصال",
      "TOGGLE_SIDEBAR": "تبديل الشريط الجانبي",
      "GO_TO_REPORTS_SIDEBAR": "الذهاب إلى شريط التقارير الجانبي",
      "MOVE_TO_NEXT_TAB": "نقل إلى علامة التبويب التالية في قائمة المحادثات",
      "GO_TO_SETTINGS": "انتقل إلى الإعدادات",
      "SWITCH_TO_PRIVATE_NOTE": "التبديل إلى الملاحظة الخاصة",
      "SWITCH_TO_REPLY": "التبديل إلى الرد",
      "TOGGLE_SNOOZE_DROPDOWN": "تبديل القائمة المنسدلة",
      "AI_ASSIST_MENU": "مساعدة AI",
      "AI_ASSIST_GRAMMAR": "تصحيح القواعد",
      "AI_ASSIST_UNIFY_LANG": "توحيد لغة الرسالة"
    }
  }
}
